<template>
  <div class="conflicts">
    <div class="error">
      <span><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /></span>
      {{ _.overlap_sessions_detected }}
    </div>
    <div class="item">
      <b>{{ room }}</b> @ {{ day }}
    </div>
    <table>
      <tbody v-for="(sval, skey) in sessions" :key="skey">
        <tr>
          <td></td>
          <td :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4' }">
            {{ formatDate(sval.day) }}
          </td>
          <td :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4', 'text-align': 'right' }">
            {{ sval.room.name }}
          </td>
        </tr>
        <tr v-if="sval.session_type">
          <td></td>
          <td :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4' }" colspan="2">
            {{ sval.session_type.name }}
          </td>
        </tr>
        <tr>
          <td>
            <div class="time">{{ sval.start_time }} &ndash; {{ sval.end_time }}</div>
          </td>
          <td :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4' }" colspan="2">
            <div class="title">
              <b v-html="(sval.code || '') + ' ' + sval.title"></b>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { API_URL } from '@/config'
export default {
  props: ['id'],
  data() {
    return {
      room: '',
      day: '',
      sessions: [],
    }
  },
  async created() {
    const sessions = await this.axios.get(API_URL + '/sessions/' + this.id + '/overlaps');
    this.setProgress(false);
    this.sessions = sessions.data;
    this.room = sessions.data[0].room.name;
    this.day = this.formatDate(sessions.data[0].day);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
@import '@/assets/scss/conflicts';
</style>